import React, { useState, useEffect } from "react";
import { useAudio } from "../../Services/AudioProvider";
import { PlaylistsAPI } from "../../api/api";
import "./Dash.css";

export default function Dashboard() {
  const { status, startEngine, stopEngine, manuallySwitchPlaylist } = useAudio();
  const [showSwitchPlaylistModal, setShowSwitchPlaylistModal] = useState(false);
  const [showStopPlayingModal, setShowStopPlayingModal] = useState(false);
  const [playlists, setPlaylists] = useState([]);
  const [switchedPlaylist, setSwitchedPlaylist] = useState("");

  useEffect(() => {
    setSwitchedPlaylist("");
  }, [playlists]);

  function formatSeconds(sec) {
    const hours = Math.floor(sec / 3600);
    const minutes = Math.floor((sec % 3600) / 60);
    const seconds = Math.floor(sec % 60);

    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    }
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  }

  const handleStart = async () => {
    try {
      await startEngine();
    } catch (err) {
      console.error("Failed to start engine:", err);
    }
  };

  const handleStop = async () => {
    try {
      setShowStopPlayingModal(false);
      await stopEngine();
    } catch (err) {
      console.error("Failed to stop engine:", err);
    }
  };

  const handleSwitchPlaylist = async () => {
    setSwitchedPlaylist("")
    setShowSwitchPlaylistModal(true);

    try {
      const res = await PlaylistsAPI.getPlaylists();
      const filtered = res.data.filter(
        (p) => p.name !== status.playlistName
      );

      setPlaylists(filtered);
    } catch (err) {
      console.error("Failed to fetch playlists:", err);
    }
  }

  const handleStopButton = () => {
    setShowStopPlayingModal(true);
  }

  const handleConfirmSwitchPlaylist = async () => {
    if (!switchedPlaylist) {
      alert("Please select a playlist first.");
      return;
    }

    setShowSwitchPlaylistModal(false)

    try {
      await manuallySwitchPlaylist(switchedPlaylist);
      setPlaylists([]);
    } catch (err) {
      console.error("Failed to start engine:", err);
    }
  }

  const statusSection = () => {
    return (
      <div className="dash-title">
        <div className="title">🎛️ Audio Engine Control Panel</div>
        {status.isRunning ? (
          <span className="running">🟢 Running</span>
        ) : (
          <span className="stopped">🔴 Stopped</span>
        )}
        {status.isRunning
          && status.switchPlaylistRequested
          && status.pendingPlaylistName !== null
          && status.pendingPlaylistName !== ""
          && <div className="playlist-panding">
            <div className="info">The playlist ({status.pendingPlaylistName}) will start after this track.</div>
          </div>}
      </div>
    );
  };

  const switchPlaylistModal = () => {
    return (
      <div className="switch-modal-overlay">
        <div className="switch-modal">
          <div>
            <h2>Manually Switch Playlist</h2>
            <div>
              <select
                value={switchedPlaylist}
                onChange={(e) => setSwitchedPlaylist(e.target.value)}
                required
              >
                <option value="">Select playlist...</option>
                {playlists.map((playlist, i) => (
                  <option key={i} value={playlist.name}>
                    {playlist.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="playlists-modal-buttons">
            <button onClick={() => handleConfirmSwitchPlaylist()} className="playlists-confirm-btn">Confirm</button>
            <button onClick={() => setShowSwitchPlaylistModal(false)} className="playlists-cancel-btn">Cancel</button>
          </div>
        </div>
      </div>
    );
  };

  const stopPlaiyngModal = () => {
        return (
      <div className="stop-playing-modal-overlay">
        <div className="stop-playing-modal">
          <div>
            <h2>Are you sure you want to stop playing?</h2>
          </div>
          <div className="playlists-modal-buttons">
            <button onClick={() => handleStop()} className="playlists-confirm-btn">Confirm</button>
            <button onClick={() => setShowStopPlayingModal(false)} className="playlists-cancel-btn">Cancel</button>
          </div>
        </div>
      </div>
    );
  }

  const playlistSection = () => {
    return (
      <div className="dash-pl dash-container">
        <div className="dash-pl-label asaid-label">Playlist</div>
        <div className="playlist-main">
          <div className="current-playlist">
            {status.playlistName && <div className="current-playlist-name">{status.playlistName}</div>}
            {status.isRunning && <div className="current-playlist-time"><strong>Elapsed Time</strong>{formatSeconds(status.playlistElapsed)}</div>}
          </div>
          {status.isRunning
            && <div className="switch-playlist">
              <button
                className="btn switch"
                onClick={handleSwitchPlaylist}
              >
                Switch
              </button>
            </div>}
        </div>
      </div>
    );
  };

  const taskSection = () => {
    return (
      <div className="dash-task dash-container">
        <div className="dash-task-label asaid-label">Task</div>
        <div className="task-main">
          <div className="current-task">
            <div className="current-task-label"><strong>next playlist</strong></div>
            <div className="current-task-content">
              {(status.isRunning && status.nextTaskPlaylistName)
                ? status.nextTaskPlaylistName
                : "-"}
            </div>
          </div>
          <div className="current-task">
            <div className="current-task-label"><strong>Start after</strong></div>
            <div className="current-task-content">
              {status.isRunning && status.nextTaskRemaining
                ? formatSeconds(status.nextTaskRemaining)
                : "-"}
            </div>
          </div>

        </div>
      </div>
    );
  }

  const trackSection = () => {
    const description = status.currentArtist
      ? `${status.currentArtist} - ${status.currentTrackTitle}`
      : null;

    const nextTrack = status.nextTrackArtist
      ? `${status.nextTrackArtist} - ${status.nextTrackTitle}`
      : null;

    return (
      <div className="dash-track dash-container">
        <div className="dash-track-label asaid-label">Track</div>
        <div className="track-info-box">
          <div className="track-info-container">
            <div className="track-title">
              {status.currentArtist && status.currentTrackTitle &&
                <div title={description}>{description}</div>}
            </div>
            <div className="track-info">
              <div className="track-info-content elapsed">
                {status.isRunning && <div>{formatSeconds(status.trackElapsed)}</div>}
              </div>
              <div className="track-info-content">
                <div>{status.progressPercent.toFixed(1)}%</div>
              </div>
              <div className="track-info-content remaining">
                {status.isRunning && <div>{formatSeconds(status.trackDuration - status.trackElapsed)}</div>}
              </div>
            </div>
            <div className="track-info-progress">
              <div className="track-progress">
                <div className="progress-bar">
                  <div
                    className="progress-bar-fill"
                    style={{ width: `${status.progressPercent}%` }}
                  ></div>
                </div>
              </div>
              <div className="track-info-content duration">
                {status.isRunning &&
                  <>
                    <strong>Duration</strong>
                    <div>{formatSeconds(status.trackDuration)}</div>
                  </>}
              </div>
              <div className="track-info-content next-track" title={nextTrack}>
                {status.isRunning &&
                  <>
                    <strong>Next</strong>
                    <div className="next-track-content">{nextTrack}</div>
                  </>}
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  };

  const buttonsSection = () => {
    return (
      <div className="status-box">
        <div className="button-row">
          <button
            className="btn start"
            onClick={handleStart}
            disabled={status.isRunning}
          >
            ▶ Start
          </button>
          <button
            className="btn stop"
            onClick={handleStopButton}
            disabled={!status.isRunning}
          >
            ⏹ Stop
          </button>
        </div>

      </div>
    );
  };

  return (
    <div className="dash-main">
      <div className="dashboard-container">
        {statusSection()}
        {playlistSection()}
        {taskSection()}
        {trackSection()}
        {buttonsSection()}
      </div>
      {showSwitchPlaylistModal && switchPlaylistModal()}
      {showStopPlayingModal && stopPlaiyngModal()}
    </div>

  );
}
